import { Child } from "@utils/interfaces/interfaces";


const notAllocatedChildrenTableFilter = (children: Child[]) => {
    return children.filter(child => child.company_class.length === 0)
}

export {
    notAllocatedChildrenTableFilter
}